<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
      class="form"
    >
      <el-row :gutter="12">
        <!-- :span="12" -->
        <el-col>
          <el-form-item label="类型：" required>
            <el-radio-group v-model="sysParamType">
              <el-radio
                size="medium"
                :label="i"
                v-for="(item, i) in paramTypeList"
                :key="i"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="sysParamType !== 0"
            label="父节点："
            prop="parentId"
            :rules="[
              { required: true, message: '父节点为空', trigger: 'blur' }
            ]"
          >
            <el-cascader
              style="width: 100%"
              v-model="curdForm.parentId"
              :props="props"
              size="mini"
              placeholder="请选择父节点"
              :options="paramTreeList"
              ref="numberInput"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col v-if="sysParamType == 0">
          <el-form-item label="字典类别：" prop="paramType">
            <el-input
              v-model="curdForm.paramType"
              placeholder="请输入字典类别（英文字母大写）"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="字典名称：" prop="paramValue">
            <el-input
              v-model="curdForm.paramValue"
              placeholder="请输入字典名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            v-if="sysParamType !== 0"
            label="数据值："
            prop="paramKey"
            :rules="[{ required: true, message: '请填写字典数据值' }]"
          >
            <el-input
              v-model="curdForm.paramKey"
              placeholder="请输入数据值"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="排序：" prop="order">
            <el-input-number
              v-model="curdForm.order"
              :min="0"
            ></el-input-number>
            <!-- <el-input
              v-model.trim="curdForm.order"
              placeholder="请填写显示顺序"
              maxlength="100"
              type="number"
            /> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom('curdForm')" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import { PARAM_TYPE } from "@/utils/constants";
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import { sysParamSave, sysParamUpdate, getSysparamTree } from "@/api/sysParam";
function mergeLeaf(item) {
  if (!item.son) return item;
  return { ...item.itself, children: item.son.map(mergeLeaf) };
}
export default {
  components: { butn },
  data() {
    return {
      Bus,
      paramTreeList: [],
      paramTypeList: PARAM_TYPE,
      sysParamType: 0,
      rules: {
        paramValue: [
          rulesFactory.required("请填写字典名称"),
          rulesFactory.size("最多输入50个字", 0, 50)
        ],
        paramType: [
          rulesFactory.required("请填写字典类型"),
          rulesFactory.size("最多输入50个字", 0, 50)
        ]
      },
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      props: {
        //树形
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true
      },
      nodeKey: "apiId",
      defaultCheckedKeys: [],
      command: function() {},
      parentName: ""
    };
  },
  created() {
    var _this = this;
    Bus.$on("ReceiveMessage", function(item) {
      _this.$nextTick(() => {
        _this.curdTitle = item == "" ? "新增字典" : "修改字典";
        _this.command = item == "" ? sysParamSave : sysParamUpdate;
        _this.CUFlag = true;
        _this.parentName = "";
        if (item) {
          item.paramValue = item.name;
          item.parentId = item.pid;
          item.paramKey = item.key;
          item.paramType = item.type;
          item.uuid = item.id;
        }
        _this.curdForm = item || { parentId: 0, order: 0, paramKey: -1 };
        // 编辑时判断父节点是否为0，判断字典类型
        _this.sysParamType = _this.curdForm.parentId == 0 ? 0 : 1;
        if (item === "123") {
          _this.CUFlag = false;
          _this.initMenuL();
        }
      });
    });
  },
  mounted() {
    this.initMenuL();
  },
  methods: {
    initMenuL() {
      getSysparamTree().then(data => {
        this.paramTreeList = data.data.map(mergeLeaf);
      });
    },
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.sysParamType > 0) {
            let parentId = this.curdForm.parentId;
            // 级联选择返回parentId为数组，这里进行赋值
            if (typeof parentId == "object") {
              this.curdForm.parentId = parentId[Number(parentId.length - 1)];
            }
          }
          const params = Object.assign({}, this.curdForm);
          this.command(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              Bus.$emit("reload");
              this.initMenuL();
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  .el-cascader.el-cascader--mini {
    /deep/ .el-input.el-input--mini .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
